export var Class;
(function (Class) {
    Class.values = [
        "any",
        "array",
        "boolean",
        "from",
        "function",
        "instance",
        "intersection",
        "inverse",
        "lazy",
        "null",
        "number",
        "object",
        "optional",
        "readonly",
        "record",
        "string",
        "tuple",
        "undefined",
        "union",
        "unknown",
    ];
})(Class || (Class = {}));
//# sourceMappingURL=Class.js.map